import { Flex, Link, Separator, Text, VStack } from "@chakra-ui/react";

import { Button } from "@components/ui/button";

function ContactPage() {
  const bookingHandler = () => {
    const url = "https://calendly.com/stackfully/quickbooks-for-monday";
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const contactHandler = () => {
    const url = "https://stackfully.co/contact/";
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // Dynamically inject the BoldDesk script once on mount
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://supportstackfully.bolddesk.com/webform/embedcode";
  //   script.type = "application/javascript";
  //   script.async = true;
  //   script.defer = true;
  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script); // cleanup
  //   };
  // }, []);

  return (
    <Flex
      align="start"
      direction="column"
      flex="1"
      maxW="2xl"
    >
      <Text
        fontSize="lg"
        fontWeight="medium"
      >
        Contact support
      </Text>
      <Text
        fontSize="sm"
        color="gray.600"
      >
        QuickBooks for monday.com
      </Text>

      <Separator
        my="24px"
        w="full"
      />

      <VStack
        align="stretch"
        gap="14px"
        width="100%"
        color="gray.600"
        bg="gray.50"
        borderRadius="md"
        p="20px"
        fontSize="sm"
      >
        <Text>
          If you have any questions, would like a demo, or need support, please reach out to us at{" "}
          <Link
            href="mailto:support@stackfully.co"
            color="blue.500"
            textDecoration="underline"
          >
            support@stackfully.co
          </Link>
          , or fill out our{" "}
          <Link
            as="button"
            onClick={contactHandler}
            color="blue.500"
            textDecoration="underline"
          >
            contact form
          </Link>
          . Our team will respond promptly.
        </Text>

        <Text>Alternatively, you can schedule a time for any matter with the button below.</Text>
      </VStack>

      <Button
        colorPalette="blue"
        onClick={bookingHandler}
        my="12px"
        alignSelf="start"
      >
        Book time with us
      </Button>

      <Separator
        my="10px"
        w="full"
      />

      {/* <Text
        fontSize="lg"
        fontWeight="medium"
        mt="3"
      >
        Support form
      </Text>

      <iframe
        id="bdfeedbackwidgetframe"
        className="bolddeskwidgetform"
        title="BoldDesk Contact Form"
        height="400"
        frameBorder="0"
        src="https://supportstackfully.bolddesk.com/webform/a3d4c76c-c8a0-4872-903d-599cce7a6432/feedbackform"
        style={{ width: "100%", border: "none", borderRadius: "8px" }}
      ></iframe> */}
    </Flex>
  );
}

export default ContactPage;
